import { render, staticRenderFns } from "./screen-card-widgets.vue?vue&type=template&id=0e122b9a&scoped=true"
import script from "./screen-card-widgets.vue?vue&type=script&lang=ts"
export * from "./screen-card-widgets.vue?vue&type=script&lang=ts"
import style0 from "./screen-card-widgets.vue?vue&type=style&index=0&id=0e122b9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e122b9a",
  null
  
)

export default component.exports